import l8n from 'l8n'

export const hosts = {
    ru: 'https://www.jivo.ru',
    en: 'https://www.jivochat.com',
    id: 'https://www.jivochat.co.id',
    pt: 'https://www.jivochat.com.br',
    tr: 'https://www.jivochat.com.tr',
    es: 'https://www.jivochat.es',
    de: 'https://www.jivochat.de',
};

export const siteUrl = () => hosts[l8n.locale] || hosts.en;



// WEBPACK FOOTER //
// ./src/scripts/siteUrl.js